var _defs, _g;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgLivepotSmallLogo(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient",
    x1: 1,
    y1: 0.5,
    x2: 0,
    y2: 0.5,
    gradientUnits: "objectBoundingBox"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#ff9c42"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#c236ff"
  })))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group_67525",
    "data-name": "Group 67525",
    transform: "translate(-64 -399)"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_22431",
    "data-name": "Rectangle 22431",
    width: 24,
    height: 24,
    rx: 12,
    transform: "translate(64 399)",
    fill: "#323232"
  }), /*#__PURE__*/React.createElement("g", {
    id: "LivePotLogo",
    transform: "translate(-787.211 353.698)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "livepot-logo",
    transform: "translate(857.209 48.053)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "LWPOLYLINE",
    transform: "translate(0 5.314)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "blurred-soft-colorful-color-background-gradient-smooth-gradation-bright-design-template-concept-photo",
    d: "M5.941,331.568.758,325.443a2.971,2.971,0,1,1,5.183-1.982v8.107Z",
    transform: "translate(0 -320.49)",
    fill: "#fff"
  })), /*#__PURE__*/React.createElement("g", {
    id: "LWPOLYLINE-2",
    "data-name": "LWPOLYLINE",
    transform: "translate(3.032 4.62)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_18",
    "data-name": "Path 18",
    d: "M185.811,280.147a3.666,3.666,0,0,0-2.971-1.518h5.941a3.667,3.667,0,0,0-2.971,1.518Z",
    transform: "translate(-182.84 -278.63)",
    fill: "#fff"
  })), /*#__PURE__*/React.createElement("g", {
    id: "LWPOLYLINE-3",
    "data-name": "LWPOLYLINE",
    transform: "translate(5.554 2.203)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_19",
    "data-name": "Path 19",
    d: "M335.408,134.169l-.448-.643.448-.676.448.676Z",
    transform: "translate(-334.96 -132.85)",
    fill: "#fff"
  })), /*#__PURE__*/React.createElement("g", {
    id: "LWPOLYLINE-4",
    "data-name": "LWPOLYLINE",
    transform: "translate(5.677 3.726)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_20",
    "data-name": "Path 20",
    d: "M342.641,225.594l-.281-.4.326-.491.326.491-.281.4Z",
    transform: "translate(-342.36 -224.7)",
    fill: "#fff"
  })), /*#__PURE__*/React.createElement("g", {
    id: "LWPOLYLINE-5",
    "data-name": "LWPOLYLINE",
    transform: "translate(4.544 2.407)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_21",
    "data-name": "Path 21",
    d: "M274.573,146.3l-.523-.473.256-.684.53.5Z",
    transform: "translate(-274.05 -145.14)",
    fill: "#fff"
  })), /*#__PURE__*/React.createElement("g", {
    id: "LWPOLYLINE-6",
    "data-name": "LWPOLYLINE",
    transform: "translate(3.733 3.034)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_22",
    "data-name": "Path 22",
    d: "M225.686,183.952l-.546-.309.09-.643.557.333Z",
    transform: "translate(-225.14 -183)",
    fill: "#fff"
  })), /*#__PURE__*/React.createElement("g", {
    id: "LWPOLYLINE-7",
    "data-name": "LWPOLYLINE",
    transform: "translate(3.032 3.884)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_23",
    "data-name": "Path 23",
    d: "M183.416,234.951l-.526-.156-.05-.566.541.174Z",
    transform: "translate(-182.84 -234.23)",
    fill: "#fff"
  })), /*#__PURE__*/React.createElement("g", {
    id: "LWPOLYLINE-8",
    "data-name": "LWPOLYLINE",
    transform: "translate(3.208 1.887)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_24",
    "data-name": "Path 24",
    d: "M193.957,114.613l-.477-.27.079-.563.488.292Z",
    transform: "translate(-193.48 -113.78)",
    fill: "#fff"
  })), /*#__PURE__*/React.createElement("g", {
    id: "LWPOLYLINE-9",
    "data-name": "LWPOLYLINE",
    transform: "translate(4.954 3.873)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_25",
    "data-name": "Path 25",
    d: "M299.058,234.3l-.278-.251.186-.5.385.365-.154.383Z",
    transform: "translate(-298.78 -233.55)",
    fill: "#fff"
  })), /*#__PURE__*/React.createElement("g", {
    id: "LWPOLYLINE-10",
    "data-name": "LWPOLYLINE",
    transform: "translate(4.313 4.192)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_26",
    "data-name": "Path 26",
    d: "M260.08,253.238l.06-.428.4.242-.031.186Z",
    transform: "translate(-260.08 -252.81)",
    fill: "#fff"
  })), /*#__PURE__*/React.createElement("g", {
    id: "LWPOLYLINE-11",
    "data-name": "LWPOLYLINE",
    transform: "translate(6.675 2.407)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_27",
    "data-name": "Path 27",
    d: "M402.793,146.3l.523-.473-.256-.684-.53.5Z",
    transform: "translate(-402.53 -145.14)",
    fill: "#fff"
  })), /*#__PURE__*/React.createElement("g", {
    id: "LWPOLYLINE-12",
    "data-name": "LWPOLYLINE",
    transform: "translate(7.625 3.034)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_28",
    "data-name": "Path 28",
    d: "M459.932,183.952l.546-.309-.09-.643-.557.333Z",
    transform: "translate(-459.83 -183)",
    fill: "#fff"
  })), /*#__PURE__*/React.createElement("g", {
    id: "LWPOLYLINE-13",
    "data-name": "LWPOLYLINE",
    transform: "translate(8.397 3.884)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_29",
    "data-name": "Path 29",
    d: "M506.4,234.951l.526-.156.05-.566-.541.174Z",
    transform: "translate(-506.4 -234.23)",
    fill: "#fff"
  })), /*#__PURE__*/React.createElement("g", {
    id: "LWPOLYLINE-14",
    "data-name": "LWPOLYLINE",
    transform: "translate(8.231 1.887)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_30",
    "data-name": "Path 30",
    d: "M496.459,114.613l.477-.27-.079-.563-.488.292Z",
    transform: "translate(-496.37 -113.78)",
    fill: "#fff"
  })), /*#__PURE__*/React.createElement("g", {
    id: "LWPOLYLINE-15",
    "data-name": "LWPOLYLINE",
    transform: "translate(6.48 3.873)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_31",
    "data-name": "Path 31",
    d: "M391.073,234.3l.278-.251-.186-.5-.385.365.154.383Z",
    transform: "translate(-390.78 -233.55)",
    fill: "#fff"
  })), /*#__PURE__*/React.createElement("g", {
    id: "LWPOLYLINE-16",
    "data-name": "LWPOLYLINE",
    transform: "translate(7.228 4.192)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_32",
    "data-name": "Path 32",
    d: "M436.365,253.238l-.06-.428-.4.242.031.186Z",
    transform: "translate(-435.9 -252.81)",
    fill: "#fff"
  })), /*#__PURE__*/React.createElement("g", {
    id: "CIRCLE",
    transform: "translate(6.064 5.305)"
  }, /*#__PURE__*/React.createElement("ellipse", {
    id: "blurred-soft-colorful-color-background-gradient-smooth-gradation-bright-design-template-concept-photo-2",
    "data-name": "blurred-soft-colorful-color-background-gradient-smooth-gradation-bright-design-template-concept-photo",
    cx: 2.971,
    cy: 2.971,
    rx: 2.971,
    ry: 2.971,
    fill: "url(#linear-gradient)"
  })), /*#__PURE__*/React.createElement("g", {
    id: "LWPOLYLINE-17",
    "data-name": "LWPOLYLINE",
    transform: "translate(6.064 10.45)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_33",
    "data-name": "Path 33",
    d: "M365.69,630.24v5.941a2.971,2.971,0,1,0,0-5.941Z",
    transform: "translate(-365.69 -630.24)",
    fill: "url(#linear-gradient)"
  })), /*#__PURE__*/React.createElement("g", {
    id: "LWPOLYLINE-18",
    "data-name": "LWPOLYLINE",
    transform: "translate(5.355)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_34",
    "data-name": "Path 34",
    d: "M323.568,1.906,322.92.977,323.568,0l.648.977Z",
    transform: "translate(-322.92)",
    fill: "#fff"
  })))))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgLivepotSmallLogo);
export default __webpack_public_path__ + "static/media/livepot-small-logo.cc17e85032623b6ac6f3691c98a8839f.svg";
export { ForwardRef as ReactComponent };